<template>
	<el-dialog :visible="visible" align-center title="请输入图片中的验证码" width="280">
		<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
	    <el-form class="captcha-form">
	      <el-form-item label="验证码">
	        <el-input v-model="captchaAnswer" autocomplete="off" />
	      </el-form-item>
	    </el-form>
	    <template #footer>
	      <div class="dialog-footer">
	        <el-button type="primary" @click="captchaClick">确定发送验证码</el-button>
	      </div>
	    </template>
	</el-dialog>
</template>

<script setup>
	import { ref,onMounted } from "vue";
	import { captchaFetch,sendemailcodeBind,sendsmscodeBind } from '@/api/common'
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const props = defineProps({
		visible: {
			type:Boolean  
		},
		secverType: {
			type:String  
		},
		codeType: {
			type:String  
		}
	});
	const emit = defineEmits(['mobileCode', 'emailCode']);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
		
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const captchaClick = () => {
		const param = {'captcha_answer':captchaAnswer.value,'captcha_id':captchaId.value}
		if(props.secverType == 'bindingmobile'){
			param['mobile'] = props.codeType;
			sendsmscodeBind(param).then((res) => {
				if (res.code == 200) {
					emit('mobileSendCode', true);
				}else{
					captchaChange()
					captchaAnswer.value = ''
				}
			})
		}
		if(props.secverType == 'bindingemail' ){
			param['email'] = props.codeType;
			sendemailcodeBind(param).then((res) => {
				if (res.code == 200) {
					emit('emailSendCode', true);
				}else{
					captchaChange()
					captchaAnswer.value = ''
				}
			})
		}
	}
	const captchaReload = () => {
		captchaChange()
	}
	
	
	onMounted(() => {
		captchaChange()
	});
</script>

<style>
</style>